import React, { useState, useEffect } from 'react';
import { FaUserCircle } from 'react-icons/fa'; // Ícone de usuário caso não haja foto
import '../styles/Parceiros.css'; // Importa o arquivo de estilos
import { useNotification } from '../components/NotificationContext';

const Parceiros = () => {
  const { showNotification } = useNotification();
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(false);

  // Função que busca a lista de parceiros
  const fetchParceiros = async () => {
    console.log("fetchParceiros was called"); // Debugging
    const userData = JSON.parse(localStorage.getItem('userData'));
    const userId = userData ? userData.id : null;

    if (!userId) {
      console.error('ID de usuário não encontrado.');
      showNotification('Erro ao identificar o usuário. Faça login novamente.', 'error');
      return;
    }

    const url = `https://x8ki-letl-twmt.n7.xano.io/api:g_BmLeE8/busca_parceiros?id=${encodeURIComponent(userId)}`;

    setLoading(true);
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setPartners(data);
    } catch (error) {
      console.error('Failed to fetch partners:', error);
    } finally {
      setLoading(false);
    }
  };

  // Dispara a busca assim que o componente é montado
  useEffect(() => {
    fetchParceiros();
  }, []);

  return (
    <div className="parceiros-page">
      <h1>Parceiros</h1>

      {loading && <p>Carregando...</p>}
      {!loading && partners.length === 0 && <p>Nenhum parceiro indicado.</p>}

      <div id="listaParceiros" className="parceiros-list">
        {partners.map((parceiro) => (
          <div key={parceiro.id} className="parceiro-item">
            {/* Se existir foto_perfil, renderiza a <img>. Caso contrário, usa o FaUserCircle */}
            {parceiro.foto_perfil ? (
              <img
                src={parceiro.foto_perfil}
                alt="Foto de perfil"
                className="parceiro-foto"
              />
            ) : (
              <FaUserCircle className="parceiro-foto-icon" />
            )}
            <div className="parceiro-info">
              <div className="parceiro-nome">
                <strong>Nome:</strong> {parceiro.name || 'N/D'}
              </div>
              <div className="parceiro-especialidade">
                <strong>Especialidade:</strong> {parceiro.especialidade || 'N/D'}
              </div>
              <div className="parceiro-detalhes">
                <div>
                  <strong>Preço/Valor:</strong> {parceiro.preco_valor || 'N/D'}
                </div>
                <div>
                  <strong>Nota:</strong> {parceiro.nota || 'N/D'}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Parceiros;
